import { render } from "./MobileMenu.vue?vue&type=template&id=d3430f22"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script